import { render } from "./ApplicantForm.vue?vue&type=template&id=0100a06e&scoped=true"
import script from "./ApplicantForm.vue?vue&type=script&lang=ts"
export * from "./ApplicantForm.vue?vue&type=script&lang=ts"

import "./ApplicantForm.vue?vue&type=style&index=0&id=0100a06e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0100a06e"

export default script